import { Constructor } from '@skylab-shared/types';
import { Query, QueryBus } from './../../query';
import { CacheStorage } from './../../storage';
import { ContextRegisterOptions, DataProvider } from './context-base';
import { LocalContext } from './local-context';

export class RootContextBase extends LocalContext {

    public constructor(
        cacheStorage: CacheStorage,
        queryBus: QueryBus,
    ) {
        super(cacheStorage, queryBus, null, null, RootContextBase.name);
    }

    public registerGloballyAsync(id: string, dataProvider: DataProvider<any>, options?: ContextRegisterOptions): Promise<void>;
    public registerGloballyAsync(query: Constructor<Query<any>>, options?: ContextRegisterOptions): Promise<void>;
    public registerGloballyAsync(queryOrId: any, dataProvider?: any, options?: ContextRegisterOptions): Promise<void> {
        return this.registerAsync(queryOrId, dataProvider, options);
    }

    public override createLocalContext(name?: string): LocalContext {
        return new LocalContext(this.storage, this.queryBus, this, this, name);
    }

    public override dispose(): void {
        super.dispose();
    }
}
